import React from 'react';
import HeaderImage from '../assets/ISOTeam.jpg';
import Footer from '../footer'
import Mandate from '../assets/mandate.png'
import BestPractices from '../assets/Best Practices.png'
import Navigation from '../navbar'
import { useNavigate } from 'react-router-dom';
import IWD from '../assets/Notice.jpg'

function Profile() {
    let navigate = useNavigate();

    const BestP = () => {
        navigate("/bestpractices")
    }

    const Man = () => {
        navigate("/mandate")
    }
    return (
        <>
            <Navigation />
            <div className="relative">
                <div className="absolute inset-0 bg-black bg-opacity-50 flex">
                    <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mx-[270px]">

                    </h1>
                </div>
                <img
                    className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[500px] xl:w-full xl:"
                    src={IWD}
                    alt="Ghana Gas GPP"
                />
            </div>
            <div>

                <h1 className="font-fjalla text-gasblue text-2xl phone:p-4 xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:m-10 xl:text-5xl xl:mx-[270px] xl:mt-[100px]">
                    
                </h1>
                <img
                    className="w-full h-auto"
                    src={IWD}
                    alt="Ghana Gas GPP"
                />
               <h1 className="font-fjalla text-gasblue text-2xl phone:p-4 xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:m-10 xl:text-5xl xl:mx-[270px] xl:mt-[100px]">
                    
                    </h1>

                <Footer />
            </div>
        </>
    );
}

export default Profile;
